import React from 'react';
import {StyledGrid} from 'presentation/components';
import {Skeleton} from '@mui/material';
import {SelectCardList} from '../../../../../modules/booking/favoriteDoctors/styles';
import {LoadingFavoritesProps} from './types';

const LoadingFavorites = ({isMobile}: LoadingFavoritesProps) => {
	return (
		<StyledGrid.Root
			p={isMobile ? 2 : 4}
			alignContent="flex-start"
			justifyContent="center"
			height="100%">
			<StyledGrid.Item key={0} sm={12} md={12} lg={8}>
				<SelectCardList
					sx={{justifyContent: isMobile ? 'flex-start' : 'center'}}
					elevation={0}
					selected={false}
					onClick={() => {}}
					cursor="default">
					<Skeleton component="div" variant="rectangular" width={247} height={24} />
				</SelectCardList>
			</StyledGrid.Item>
			<StyledGrid.Item key={1} sm={12} md={12} lg={8}>
				<SelectCardList
					elevation={0}
					sx={{justifyContent: isMobile ? 'flex-start' : 'center'}}
					selected={false}
					onClick={() => {}}
					cursor="default">
					<Skeleton component="div" variant="rectangular" width={247} height={24} />
				</SelectCardList>
			</StyledGrid.Item>
		</StyledGrid.Root>
	);
};

export {LoadingFavorites};
